import { createAsyncThunk } from '@reduxjs/toolkit';

import { OverviewService } from 'api';

import { StatementData } from 'models';

export const getUserProfitSecondaryMarket = createAsyncThunk(
	'user/getUserProfitSecondaryMarket',
	async (payload: StatementData) => {
		return await OverviewService.getSecondaryMarketProfit(payload);
	},
);
